import { createSlice } from "@reduxjs/toolkit";
import { addPracticeInfoDetailsAPI } from "./AddPracticeActions";
import { getApiErrorMessage } from "../../utils/commonUtilities";

const addPracticeDetails = createSlice({
    name: "addPracticeDetails",
    initialState: {
        isAddPracticeDataLoading: false,
        practiceDetails: {},
        addPracticeError: null,
        addPracticeErrorMsg: ""
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(addPracticeInfoDetailsAPI.pending, (state) => {
                state.isAddPracticeDataLoading = true;
                state.addPracticeError = null;
            })
            .addCase(addPracticeInfoDetailsAPI.fulfilled, (state, action) => {
                state.isAddPracticeDataLoading = false;
                if (!action.payload.success) {
                    if (
                        action.payload.data.metadata?.outcome.additionalDetails[0]
                            ?.additionalInfo
                    ) {
                        state.addPracticeError = false;
                        state.practiceDetails = {};
                    }
                    else {
                        state.addPracticeError = true;
                        state.addPracticeErrorMsg = getApiErrorMessage(action.payload.status);
                    }
                } else {
                    state.addPracticeError = false;
                    state.practiceDetails = action.payload;
                }
            })
            .addCase(addPracticeInfoDetailsAPI.rejected, (state, action) => {
                state.isAddPracticeDataLoading = false;
                state.addPracticeError = action.error.message;
            });
    },
});


export const { addPractice } = addPracticeDetails.actions;
export const addPracticeDetailsReducer = addPracticeDetails.reducer;